



























































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component

export default class ComponentRelatorioMensalFontePagadora extends Vue {
  @Prop(Object) relatorio
  @Prop(Number) startDate
  @Prop(Number) finalDate
  @Prop(String) type

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }
}
